import React, { Suspense, lazy } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import theme from "./styles/theme";
import GlobalStyles from "./styles/GlobalStyles";
import { ToastProvider } from "./context/ToastContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import PageSpinner from "./components/common/LoadingSpinner";

library.add(fas, fab);

const Home = lazy(() => import("./pages/Home/Home"));
const ServicesPage = lazy(() => import("./pages/Services/Services"));
const Gallery = lazy(() => import("./pages/Gallery/Gallery"));
const AboutContact = lazy(() => import("./pages/AboutContact/AboutContact"));
const Careers = lazy(() => import("./pages/Careers/Careers"));
const AdminPortal = lazy(() => import("./pages/Admin/AdminPortal"));
const WaterFeatures = lazy(() => import("./pages/WaterFeatures/WaterFeatures"));

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

const AppShell = () => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && <Navbar />}
      <Suspense fallback={<PageSpinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/portfolio" element={<Navigate to="/gallery" replace />} />
          <Route path="/about" element={<AboutContact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/water-fountains-waterfall-walls" element={<WaterFeatures />} />
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      {!isAdminRoute && <Footer />}
    </>
  );
};

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <ToastProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </ToastProvider>
  </ThemeProvider>
);

export default App;
